/**
 * Create Event draft persistence — web (localStorage) equivalent of mobile's
 * AsyncStorage.getItem/setItem(Keys.CREATE_EVENT_DRAFT + UserId) in
 * create-event-update/index.js. Create mode only; never used for edit.
 */

const DRAFT_KEY_PREFIX = "ps_create_event_draft_";

/** Best-effort stable per-user id, defensive about which field this panel's stored user object uses. */
export const resolveDraftUserKey = (user) =>
  String(
    user?.UserId ?? user?.Id ?? user?.BusinessDetails?.UserId ?? user?.Email ?? user?.UserName ?? "default"
  );

const draftKey = (userKey) => `${DRAFT_KEY_PREFIX}${userKey}`;

export const hasDraft = (userKey) => {
  try {
    return Boolean(localStorage.getItem(draftKey(userKey)));
  } catch {
    return false;
  }
};

export const loadDraft = (userKey) => {
  try {
    const raw = localStorage.getItem(draftKey(userKey));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveDraft = (userKey, data) => {
  try {
    localStorage.setItem(draftKey(userKey), JSON.stringify({ ...data, savedAt: Date.now() }));
    return true;
  } catch {
    return false;
  }
};

export const clearDraft = (userKey) => {
  try {
    localStorage.removeItem(draftKey(userKey));
  } catch {
    // ignore — non-critical
  }
};
